module.exports = __webpack_public_path__ + "static/media/36_A.8fe28d40.png";